import type { AuthSession } from './AuthService';
import type { ImpersonationState } from './ImpersonationStore';
import type { GraduateStaffKind } from './GraduateStaffModeStore';

export function graduateStaffAccess(account: AuthSession | null, impersonation: ImpersonationState | null) {
  if (!account) return { canEvaluate: false, canReview: false };
  if (impersonation) return {
    canEvaluate: impersonation.session.kind === 'GraduateEvaluator',
    canReview: impersonation.session.kind === 'GraduateFaculty',
  };
  // The API role list takes precedence over legacy or cached permission flags.
  if (Array.isArray(account.roles)) {
    const roles = account.roles.map(role => role.toLowerCase());
    return {
      canEvaluate: roles.some(role => ['accessadministrator', 'graduateadministrator', 'graduateevaluator'].includes(role)),
      canReview: roles.includes('graduatefaculty'),
    };
  }
  return {
    canEvaluate: Boolean(account.isGraduateAdministrator || account.canEvaluateGraduate),
    canReview: Boolean(account.canReviewGraduateFaculty),
  };
}

export function graduateStaffKind(account: AuthSession | null, impersonation: ImpersonationState | null,
  selected: GraduateStaffKind): GraduateStaffKind {
  const { canEvaluate, canReview } = graduateStaffAccess(account, impersonation);
  return canReview && (!canEvaluate || selected === 'GraduateFaculty') ? 'GraduateFaculty' : 'GraduateEvaluator';
}
